import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { FeatureFlagService } from '../services/feature-flag.service';

export const previewDemoGuard: CanActivateFn = () => {
  const router = inject(Router);
  const featureFlagService = inject(FeatureFlagService);

  return featureFlagService.getCurrentFlags().pipe(
    map((flags) => flags['PREVIEW_DEMO'] === true
      ? true
      : router.createUrlTree(['/dashboard'])),
    catchError(() => of(router.createUrlTree(['/dashboard'])))
  );
};
